export default key => {
  try {
    const raw = global.localStorage.getItem(key);
    if (raw) {
      return JSON.parse(raw);
    }
  } catch (e) {
    // ignore exceptions - can occur on IE (http://stackoverflow.com/a/20848924)
  }
  return undefined;
};
